import { Dialog } from "primereact/dialog";
import { InputSwitch } from "primereact/inputswitch";
import { useEffect, useState } from "react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { apigetCurrentAffairsHook } from "../../services/apiCurrentaffairs/apicurrentaffairs";
import { X } from "lucide-react";

export default function Addandeditform({ visible, setVisible, formdata, handlechange, handlesave, handleupdate }) {
  const [editorContent, setEditorContent] = useState(formdata.Content || "");
  const [dropdownhookData, setDropdownhookData] = useState([]);
  const [pdfFiles, setPdfFiles] = useState(formdata.pdfFiles || [{ title: "", file: null }]);
  const [isEnableHeader, setIsEnableHeader] = useState(formdata.isEnableHeader || false);
  const [isDownloadsEnabled, setIsDownloadsEnabled] = useState(formdata.isDownloadsEnabled || false);

  useEffect(() => {
    setEditorContent(formdata.Content || "");
    setPdfFiles(formdata.pdfFiles || [{ title: "", file: null }]);
    setIsEnableHeader(formdata.isEnableHeader || false);
    setIsDownloadsEnabled(formdata.isDownloadsEnabled || false);
  }, [formdata]);

  const handleEditorChange = (content) => {
    setEditorContent(content);
    handlechange({ target: { name: "Content", value: content } });
  };

  useEffect(() => {
    const fetchHookData = async () => {
      try {
        const data = await apigetCurrentAffairsHook();
        if (data && data.resdata) {
          setDropdownhookData(data.resdata);
        }
      } catch (error) {
        console.error('Error fetching current affairs hooks:', error);
      }
    };

    fetchHookData();
  }, []);

  const handlePdfTitleChange = (index, value) => {
    const updatedPdfFiles = [...pdfFiles];
    updatedPdfFiles[index].title = value;
    setPdfFiles(updatedPdfFiles);
    handlechange({ target: { name: "pdfFiles", value: updatedPdfFiles } });
  };

  const handlePdfFileChange = (index, file) => {
    const updatedPdfFiles = [...pdfFiles];
    updatedPdfFiles[index].file = file;
    setPdfFiles(updatedPdfFiles);
    handlechange({ target: { name: "pdfFiles", value: updatedPdfFiles } });
  };

  const addPdfField = () => {
    setPdfFiles([...pdfFiles, { title: "", file: null }]);
  };

  const removePdfField = (index) => {
    const updatedPdfFiles = pdfFiles.filter((_, i) => i !== index);
    setPdfFiles(updatedPdfFiles);
    handlechange({ target: { name: "pdfFiles", value: updatedPdfFiles } });
  };

  const handleHeaderSwitchChange = (value) => {
    setIsEnableHeader(value);
    handlechange({ target: { name: "isEnableHeader", value } });
  };

  const handleDownloadsSwitchChange = (value) => {
    setIsDownloadsEnabled(value);
    handlechange({ target: { name: "isDownloadsEnabled", value } });
  };

  return (
    <Dialog header="Current Affairs Form" visible={visible} onHide={() => { if (!visible) return; setVisible(false); }} style={{ width: "50vw" }} breakpoints={{ "960px": "75vw", "641px": "100vw" }}
      maximizable
    >
      <form onSubmit={!formdata._id ? handlesave : handleupdate}>
        <div className="grid grid-cols-1 gap-y-2">
          <div>
            <div>
              <label>Content</label>
            </div>
            <SunEditor setContents={editorContent} onChange={handleEditorChange}
              setOptions={{
                defaultStyle: "font-family: Arial, sans-serif;",
                font: ["Arial"],
                buttonList: [
                  ["undo", "redo", "fontSize", "formatBlock"],
                  ["bold", "underline", "italic", "strike", "subscript", "superscript", "removeFormat"],
                  ["fontColor", "hiliteColor", "textStyle"],
                  ["align", "list", "lineHeight"],
                  ["outdent", "indent"],
                  ["table", "link", "image", "video"],
                  ["fullScreen", "showBlocks", "codeView"],
                  ["preview", "print"],
                ],
              }}
              height="350px"
            />
          </div>

          <div>
            <div>
              <label>Current Affair Type</label>
            </div>
            <select name="Current_Affair_Type" value={formdata['Current_Affair_Type']} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" onChange={handlechange} required>
              <option value="">---Select---</option>
              {dropdownhookData
                .filter(ca => ca.currentaffairstype && ca.currentaffairstype.trim() !== '')
                .map((ca) => (
                  <option key={ca._id} value={ca.currentaffairstype}>
                    {ca.currentaffairstype}
                  </option>
                ))}
            </select>
          </div>

          <div>
            <div>
              <label>Category</label>
            </div>
            <select name="Category" value={formdata['Category']} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" onChange={handlechange} required>
              <option value="">---Select---</option>
              {dropdownhookData
                .filter(ca => ca.currentAffairsCategory && ca.currentAffairsCategory.trim() !== '')
                .map((ca) => (
                  <option key={ca._id} value={ca.currentAffairsCategory}>
                    {ca.currentAffairsCategory}
                  </option>
                ))}
            </select>
          </div>

          <div>
            <div>
              <label>Title</label>
            </div>
            <input type="text" name="Title" value={formdata["Title"] || ""} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" onChange={handlechange} required/>
          </div>
          <div>
            <div>
              <label>Month</label>
            </div>
            <select 
              name="Month" 
              value={formdata['Month'] || ''}
              className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" 
              onChange={handlechange} 
              required
            >
              <option value="">---Select Month---</option>
              <option value="January">January</option>
              <option value="February">February</option>
              <option value="March">March</option>
              <option value="April">April</option>
              <option value="May">May</option>
              <option value="June">June</option>
              <option value="July">July</option>
              <option value="August">August</option>
              <option value="September">September</option>
              <option value="October">October</option>
              <option value="November">November</option>
              <option value="December">December</option>
            </select>
          </div>

          <div>
            <div>
              <label>Year</label>
            </div>
            <select name="Year" value={formdata['Year'] || ''} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" onChange={handlechange} required>
              <option value="">---Select Year---</option>
              {Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i).map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>

          <div>
            <div className="flex items-center justify-between mb-2">
              <label className="font-semibold">PDF Files</label>
              <button type="button" onClick={addPdfField}className="px-3 py-1 text-xs text-white bg-blue-500 rounded-lg hover:bg-blue-600">
                + Add PDF
              </button>
            </div>
            {pdfFiles.map((pdf, index) => (
              <div key={index} className="p-3 mb-2 border rounded-lg bg-gray-50">
                <div className="flex items-start gap-2">
                  <div className="flex-1">
                    <label className="text-sm">PDF Title</label>
                    <input type="text" placeholder="Enter PDF title" value={pdf.title} onChange={(e) => handlePdfTitleChange(index, e.target.value)} className="w-full px-3 py-2 mt-1 border rounded-lg outline-none"/>
                  </div>
                  <div className="flex-1">
                    <label className="text-sm">PDF File</label>
                    <input type="file" accept=".pdf" onChange={(e) => handlePdfFileChange(index, e.target.files[0])} className="w-full px-3 py-2 mt-1 border rounded-lg outline-none"/>
                  </div>
                  {pdfFiles.length > 1 && (
                    <button type="button" onClick={() => removePdfField(index)} className="px-1 py-1 text-white bg-red-500 rounded-full hover:bg-red-600">
                     <X size={15}/>
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className="flex items-center justify-between p-3 border rounded-lg">
            <label className="font-medium">Is Enable for Header</label>
            <InputSwitch checked={isEnableHeader} onChange={(e) => handleHeaderSwitchChange(e.value)}/>
          </div>

          <div className="flex items-center justify-between p-3 border rounded-lg">
            <label className="font-medium">Downloads</label>
            <InputSwitch checked={isDownloadsEnabled} onChange={(e) => handleDownloadsSwitchChange(e.value)}/>
          </div>

          <div>
            <div>
              <label>Status</label>
            </div>
            <select name="Status" className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" onChange={handlechange} value={formdata.Status || ""} required>
              <option value="">---Select a Status---</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
        </div>

        <div className="flex justify-end gap-5 mt-5">
          <button type="button" onClick={() => setVisible(false)}>Cancel</button>
          <button type="submit" className="px-4 py-2 text-white bg-secondary rounded-xl">
            <i className="fi fi-br-check"></i>{" "}
            {!formdata._id ? "Save" : "Update"}
          </button>
        </div>
      </form>
    </Dialog>
  );
}